import React from 'react';
import {useIntl} from 'react-intl';

interface PlaybackSpeedButtonProps {
    rate: number;
    onClick: () => void;
    shape: 'round' | 'rounded-square';
    className?: string;
}

const SHAPE_CLASSES = {
    'round': 'rounded-full bg-brand',
    'rounded-square': 'rounded-xl bg-indigo-600',
};

const PlaybackSpeedButton: React.FC<PlaybackSpeedButtonProps> = ({rate, onClick, shape, className}) => {
    const intl = useIntl();
    const label = `${rate}x`;
    return (
        <button
            type="button"
            data-testid="audio-player.speed"
            aria-label={intl.formatMessage({id: 'audioPlayer.playbackSpeed', defaultMessage: 'Playback speed {rate}x'}, {rate})}
            onClick={onClick}
            className={`${SHAPE_CLASSES[shape]} min-h-8 min-w-8 flex justify-center items-center text-white text-xs font-medium tabular-nums cursor-pointer hover:opacity-90 ${className ?? ''}`}
        >
            {label}
        </button>
    );
};

export default PlaybackSpeedButton;
